import { motion } from "motion/react";

export function FindingCard({
  icon,
  decorativeIcon,
  category,
  findings,
  delay = 0,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.8,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      whileHover={{ scale: 1.01 }}
      className="relative flex flex-col md:flex-row gap-6 p-6 md:p-8 rounded-2xl bg-gradient-to-br from-white/5 to-transparent item-border border-white/10 backdrop-blur-sm"
    >
      {/* Icon */}
      <div className="flex-shrink-0">
        <div className="bg-[#fd5b38]/10 rounded-2xl w-16 h-16 flex items-center justify-center">
          {icon}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 space-y-4">
        <h4 className="text-white text-xl md:text-2xl">{category}</h4>
        <p className="text-[#fd5b38]">Summary of Findings:</p>
        <p className="text-[#d1d5dc] leading-relaxed">{findings}</p>
      </div>

      {/* Decorative Icon */}
      <div className="hidden lg:flex flex-shrink-0 items-center justify-center">
        <div className="bg-white/5 rounded-xl w-32 h-32 flex items-center justify-center item-border border-white/10">
          {decorativeIcon}
        </div>
      </div>
    </motion.div>
  );
}
